import { useEffect } from 'react'
import {
  Box,
  Text,
  Divider,
  SimpleGrid
} from '@chakra-ui/react';
import { useTokenStore } from '../../Store/useTokenStore'
import { useTokenFetcher } from '../../hooks/useTokenFetcher'
import { CreditPackCard } from '../../components/CreditPackCard';
import { CreditUsageCard } from '../../components/CreditUsageCard';

const creditPacks = [
  { credits: 50, price: "$3" },
  { credits: 100, price: "$5" },
  { credits: 250, price: "$10" },
  { credits: 500, price: "$18" },
  { credits: 1000, price: "$30" },
];

export const TokenUsagePage = ({id, isPro}) => {
  const { refreshTokens } = useTokenFetcher()
  const { tokenData } = useTokenStore()
  const { creditsUsed, creditLimit, extraCredits, totalCredits, renewalDate } = tokenData;

  useEffect(() => {
    refreshTokens(id)
  }, [id, refreshTokens])

  return (
    <Box bg="gray.50" borderRadius="xl">
      <CreditUsageCard 
        creditsUsed={creditsUsed}
        creditLimit={creditLimit}
        extraCredits={extraCredits}
        totalCredits={totalCredits}
        expiryDate={renewalDate}
        isPro={isPro}
      />
      <Divider my={6} borderColor="gray.300" />
      <Text fontSize="xl" fontWeight="semibold" mb={6}>
        Buy Credits
      </Text>
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={6}
        w="full"
        my={6}
      >
        {creditPacks.map((pack, index) => (
          <CreditPackCard key={index} {...pack} />
        ))}
      </SimpleGrid>
    </Box>
  )
}
